import React from 'react';
import { motion } from 'framer-motion';
import { Zap, ShieldCheck, Lock, CreditCard, Clock, Check, Wheat } from 'lucide-react';
import { Countdown } from './Countdown';
export function FinalCTA() {
  return <section className="py-14 bg-petroleum relative overflow-hidden border-t border-electric/20" data-id="element-239">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-40" data-id="element-240"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-241">
        {/* Framed Countdown Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-10" data-id="element-242">
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-energy to-electric rounded-3xl blur-xl opacity-25 animate-pulse" data-id="element-243"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/20" data-id="element-244">
            {/* Decorative wheat flourish in background */}
            <div className="absolute -top-16 -right-16 opacity-10 pointer-events-none rotate-12" data-id="element-245">
              <Wheat className="w-48 h-48 text-electric" data-id="element-246" />
            </div>
            <div className="absolute -bottom-16 -left-16 opacity-10 pointer-events-none -rotate-12" data-id="element-247">
              <Wheat className="w-48 h-48 text-electric" data-id="element-248" />
            </div>

            {/* Organic dot pattern background */}
            <div className="absolute inset-0 opacity-[0.18] pointer-events-none" style={{
            backgroundImage: 'radial-gradient(circle, rgba(125,255,47,0.35) 1.2px, transparent 1.5px)',
            backgroundSize: '18px 18px'
          }} data-id="element-249"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-250"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-251"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-252"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-253"></div>

            <div className="relative z-10" data-id="element-254">
              <div className="inline-flex items-center gap-2 bg-electric text-graphite px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-255">
                <Wheat className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-256" />
                Última oportunidad
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight mb-5" data-id="element-257">
                <span className="text-white" data-id="element-258">El precio </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-energy to-electric drop-shadow-[0_0_12px_rgba(125,255,47,0.4)]" data-id="element-259">
                  cierra en:
                </span>
              </h2>
              <Countdown data-id="element-260" />
              <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-261"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-6 mb-8" data-id="element-262">
          {/* Basic Plan Mini */}
          <div className="bg-graphite border border-white/10 rounded-2xl p-6 text-center hover:border-electric/30 transition-all" data-id="element-263">
            <h3 className="text-xl font-bold mb-2" data-id="element-264">
              📘 KIT NEGOCIO FITNESS IA
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-265">
              6 Tomos + 6 Bonos · De 0 a Negocio Digital Escalable
            </p>
            <div className="mb-6" data-id="element-266">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-267">
                $36.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-268">
                $19.990
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCcl7gvQ5vY0b1hyVWyPac/es-ar?_r=AQABbv65Q0gCPXZYhJR_L9tgdXLybHYG3RIokQMwoWPr7Js&cart_link_id=HjseKSgA&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-269">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-270">
                <Zap className="w-3.5 h-3.5 text-electric fill-electric" data-id="element-271" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-272">
                QUIERO MI KIT
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-273">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-274" />
              </span>
            </a>
          </div>

          {/* Pro Plan Mini */}
          <div className="bg-gradient-to-b from-[#13261a] to-petroleum border-2 border-electric rounded-2xl p-6 text-center relative glow-electric" data-id="element-275">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-3 py-0.5 rounded-full text-xs flex items-center gap-1" data-id="element-276">
              <Zap className="w-3 h-3 fill-graphite" data-id="element-277" /> MÁS POPULAR
            </div>
            <h3 className="text-xl font-bold mb-2 text-gold" data-id="element-278">
              🏆 KIT + PROTOCOLO 24/7
            </h3>
            <p className="text-sm text-textsecondary mb-4" data-id="element-279">
              6 Tomos + 6 Bonos + El Protocolo de Ejecución 24/7
            </p>
            <div className="mb-6" data-id="element-280">
              <span className="text-textsecondary line-through text-sm mr-2" data-id="element-281">
                $49.990
              </span>
              <span className="text-3xl font-extrabold text-white" data-id="element-282">
                $27.990
              </span>
            </div>
            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCclFbI7sWfiYKDB5A4UUc/es-ar?_r=AQABcFNgsdfWUaxaEwGfEodD0yzqrQmh0yGFx7BMeD6yBWU&cart_link_id=tRAHM9um&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-yellow-300 via-gold to-yellow-400 hover:from-yellow-200 hover:via-yellow-300 hover:to-gold text-graphite font-bold py-3 rounded-xl transition-all duration-300 flex items-center justify-between gap-2 pl-3 pr-2 shadow-md hover:shadow-lg hover:shadow-gold/40" data-id="element-283">
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite/15 border border-graphite/20 flex items-center justify-center" data-id="element-284">
                <Zap className="w-3.5 h-3.5 text-graphite fill-graphite" data-id="element-285" />
              </span>
              <span className="flex-1 text-center text-sm tracking-wide" data-id="element-286">
                QUIERO EL KIT + PROTOCOLO 24/7
              </span>
              <span className="flex-shrink-0 w-7 h-7 rounded-lg bg-graphite text-gold flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-287">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-288" />
              </span>
            </a>
          </div>
        </div>

        {/* Trust Row */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12 text-sm text-textsecondary font-medium" data-id="element-289">
          <div className="flex items-center gap-2" data-id="element-290">
            <Lock className="w-5 h-5 text-electric" data-id="element-291" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-292">
            <Clock className="w-5 h-5 text-electric" data-id="element-293" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-294">
            <ShieldCheck className="w-5 h-5 text-electric" data-id="element-295" /> Garantía 7 días
          </div>
          <div className="flex items-center gap-2" data-id="element-296">
            <CreditCard className="w-5 h-5 text-electric" data-id="element-297" /> Mercado Pago ·
            Tarjeta · Transferencia
          </div>
        </div>
      </div>
    </section>;
}